import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';
import * as c from './constants';

export const getProfile = () => {
  req.get({
    key: c.PROFILE,
    url: '/profile/v1/my/profile',
    transform: ({ data }) => data,
  });
};

export const uplpoadOrgPhoto = (payload) => {
  req.put({
    key: c.PROFILE_UPLOAD_ORG_PHOTO,
    payload,
    url: '/profile/v1/my/profile',
    onSuccess: () => {
      toastSuccess('Uploaded successfully!');
      setTimeout(() => {
        getProfile();
      }, 2000);
    },
  });
};
